import { stakingEndpoints } from "./staking.api"

export const {
  useGetStakingsListQuery,
  useCreateStakingMutation,
  useCheckCompletedStakingsMutation,
  useCancelStakingMutation,
  useConfirmStakingMutation,
  useStakingBonusSheetQuery,
  useStakingBonusQuery,
  useMyStakingBonusQuery,
  useStakingBonusByUserIdQuery,
  useCheckReviewedStakingQuery,
  endpoints: {
    getStakingsList,
    createStaking,
    checkCompletedStakings,
    cancelStaking,
    confirmStaking,
    stakingBonusSheet,
    stakingBonus,
    stakingBonusByUserId
  }
} = stakingEndpoints
